export default __webpack_public_path__ + "static/media/Version (4) - Half-Blood Prince_06.7dec40a0.jpg";